import { render, staticRenderFns } from "./PointsDraggable.vue?vue&type=template&id=93099492&scoped=true&"
import script from "./PointsDraggable.vue?vue&type=script&lang=js&"
export * from "./PointsDraggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93099492",
  null
  
)

export default component.exports